module.exports = __webpack_public_path__ + "static/media/1.12.9d84bc63.png";